'use strict'

function initializeAnchorNavigation() {

  $(document).ready(function () {
    $( window ).bind('scroll.anchornav', function() {
      if (!$('.anchor-nav').length) {
        return
      }
      showAnchorNav()
      toggleAnchorNav()
    });
    $('.js-scroll-link').on('click', function () {
      $(window).off('scroll.anchornav')
      const $this = $(this);
      const $targetIndicator = $this.attr('href').substr(1)
      if ($targetIndicator && $targetIndicator.length) {
        const $target = $('#' + $targetIndicator)
        if ($target && $target.length) {
          $('.js-scroll-link').removeClass('active')
          $this.addClass('active')
          scrollToActive($this)
          $('html, body').animate({
            scrollTop: $target.offset().top - 180
          }, 300, function() {
            $( window ).bind('scroll.anchornav', function () {
              showAnchorNav()
              toggleAnchorNav()
              if ($(this).scrollTop() > 400) {
                $('.scroll-top-button').fadeIn().css('display','flex');
              } else {
                $('.scroll-top-button').fadeOut();
              }
            })
          });
        }
      }
    })
  })
  function showAnchorNav() {
    const $hero = $('.hero')
    const $anchorNav = $('.anchor-nav')
    if (!$hero.length || !$anchorNav.length) {
      return
    }

    const anchorNavTop = $anchorNav.offset().top
    const heroBottom = $hero.offset().top + $hero.outerHeight() + 80

    if (anchorNavTop > heroBottom) {
      $anchorNav.addClass('visible')
    } else {
      $anchorNav.removeClass('visible')
      $('.js-scroll-link').removeClass('active')
    }
  }
  function toggleAnchorNav() {
    const anchorContainer = $('.anchor-container')
    const $anchorNav = $('.anchor-nav')
    const anchorNavBottom = $anchorNav.offset().top + $anchorNav.outerHeight()

    anchorContainer.each(function (i, el) {
      let $this = $(el)
      const $target = $('.js-scroll-link')
      const top_of_element = $this.offset().top - 120;

      if (anchorNavBottom > top_of_element){
        $target.each(function (i, el) {
          const $targetEl = $(el)
          if($this.attr('id') === $targetEl.attr('href').substr(1)) {
            $targetEl.addClass('active')
          } else {
            $targetEl.removeClass('active')
          }
        })
      }
    })
  }
  function scrollToActive($this) {
    const tabNavigation = $('.anchor-nav__list')
    const leftPos = $this.position().left - $this.width() - 60
    tabNavigation.animate({ scrollLeft: leftPos });
  }
}

export default initializeAnchorNavigation
